import {
  Box,
  Checkbox,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  withStyles
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { DateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import React from "react";

import MomentUtils from "@date-io/moment";
import {
  addFleetGearsOptions,
  addFleetVesselTypeOptions,
} from "../../../constants";

import CheckBoxIcon from "@material-ui/icons/CheckBox";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import moment from "moment";
import { LuInbox } from "react-icons/lu";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}))(Tooltip);
export default function ManualAddFleet(props) {
  const {
    loader = false,
    updatedSinceLastOptions,
    autoFilters,
    onChangeAutoFilters,
    onSubmitAutoSearch,
    emailFleetList,
    selectedAutoFleet,
    onChangeDateOpening,
    onAutoFleetListCheckBox,
    allSelected,
    addFleetRegionOptions,
    onSelectAllAutoFleet,
    setValidationVesselFromAuto,
    setValidationVesselFromAutoIndex,
    savePortListByIndex,
    portLoading,
    onChangeNewPortValue,
    delayPortSearch,
    onSaveAllVessels
  } = props;

  const regionRef = React.useRef(null);
  const [dynamicLimitTags, setDynamicLimitTags] = React.useState(3);

  React.useEffect(() => {
    if (!regionRef.current) return;

    const updateLimit = () => {
      if (!regionRef.current) return;
      const width = regionRef.current.clientWidth;
      const count = Math.max(1, Math.floor((width - 65) / 170));
      setDynamicLimitTags(count);
    };

    updateLimit();

    const resizeObserver = new ResizeObserver(() => {
      updateLimit();
    });

    resizeObserver.observe(regionRef.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  const indeterminateChecked =
    selectedAutoFleet.length &&
    selectedAutoFleet.length !== emailFleetList.length;

  return (
    <div className="w-full flex flex-col">
      <div className="filter-bar-container w-full flex flex-wrap items-end gap-2 md:gap-3 mb-2">
        <div className="w-[calc(50%-4px)] md:w-[170px]">
          <label className="auto-add-fleet-label">Updated since last</label>
          <Autocomplete
            id="combo-box-demo"
            options={updatedSinceLastOptions()}
            value={autoFilters.updateSince || {}}
            onChange={(e, value) => onChangeAutoFilters("updateSince", value)}
            getOptionLabel={(option) => option.label}
            getOptionSelected={(option, value) =>
              option.value === value.value
            }
            fullWidth
            disableClearable
            renderInput={(params) => (
              <TextField {...params} size="small" variant="outlined" />
            )}
          />
        </div>

        <div ref={regionRef} className="order-last md:order-none w-full md:w-auto md:flex-1 md:min-w-[200px]">
          <label className="auto-add-fleet-label">Region</label>
          <Autocomplete
            multiple
            id="checkboxes-tags-demo"
            options={addFleetRegionOptions}
            value={autoFilters.portRegion || {}}
            fullWidth
            onChange={(e, value) => onChangeAutoFilters("portRegion", value)}
            limitTags={dynamicLimitTags}
            disableClearable
            disableCloseOnSelect
            getOptionLabel={(option) => option.label}
            getOptionSelected={(option, value) =>
              option.value === value.value
            }
            renderOption={(option, { selected }) => (
              <React.Fragment>
                <Checkbox
                  icon={icon}
                  size="small"
                  checkedIcon={checkedIcon}
                  checked={selected}
                />
                <span style={{ fontSize: 11 }}>{option.label}</span>
              </React.Fragment>
            )}
            renderInput={(params) => (
              <TextField {...params} variant="outlined" size="small" />
            )}
          />
        </div>

        <div className="w-[calc(50%-4px)] md:w-[170px]">
          <label className="auto-add-fleet-label">Vessel Type</label>
          <Autocomplete
            id="combo-box-demo"
            options={addFleetVesselTypeOptions}
            value={autoFilters.vesselType || {}}
            onChange={(e, value) => onChangeAutoFilters("vesselType", value)}
            getOptionLabel={(option) => option.label}
            getOptionSelected={(option, value) =>
              option.value === value.value
            }
            fullWidth
            disableClearable
            renderInput={(params) => (
              <TextField {...params} size="small" variant="outlined" />
            )}
          />
        </div>

        <div className="w-[calc(50%-4px)] md:w-[170px]">
          <label className="auto-add-fleet-label">Gears</label>
          <Autocomplete
            id="combo-box-demo"
            options={addFleetGearsOptions}
            value={autoFilters.gear || {}}
            onChange={(e, value) => onChangeAutoFilters("gear", value)}
            getOptionLabel={(option) => option.label}
            getOptionSelected={(option, value) =>
              option.value === value.value
            }
            fullWidth
            disableClearable
            renderInput={(params) => (
              <TextField {...params} size="small" variant="outlined" />
            )}
          />
        </div>

        <div className="ml-auto order-last">
          <button className="search-by-auto" onClick={onSubmitAutoSearch}>
            Search
          </button>
        </div>
      </div>
      <div className="w-full mt-1">
        <TableContainer
          className="auto-add-from-mail"
          component={Paper}
          style={{ minHeight: "auto", overflow: loader ? "hidden" : "auto" }}
        >
          <Table className="fleet-list-table [&_th]:whitespace-nowrap [&_td]:whitespace-nowrap">
            <TableHead>
              <TableRow>
                <TableCell>
                  <Checkbox
                    size="small"
                    color="primary"
                    indeterminate={indeterminateChecked}
                    checked={allSelected}
                    onChange={onSelectAllAutoFleet}
                  />
                </TableCell>
                <TableCell>Vessel Name</TableCell>
                <TableCell>DWT</TableCell>
                <TableCell>Port
                  <LightTooltip title="Required">
                    <span className="required-span">*</span>
                  </LightTooltip>
                </TableCell>
                <TableCell>Port Region</TableCell>

                {/* <TableCell>Email Date Opening</TableCell> */}
                <TableCell>Date Opening
                  <LightTooltip title="Required">
                    <span className="required-span">*</span>
                  </LightTooltip>
                </TableCell>
                <TableCell>Gears</TableCell>
                <TableCell>Email Subject</TableCell>
                <TableCell>Email Date</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loader ? (
                <TableRow>
                  <TableCell colSpan={10} align="center" className="!bg-white">
                    <Box display="flex" justifyContent="center" alignItems="center" height="200px">
                      <CircularProgress size={20} />
                    </Box>
                  </TableCell>
                </TableRow>
              ) : emailFleetList.length ? (
                emailFleetList.map((item, index) => {
                  const {
                    id,
                    vesselName = "",
                    email_date = "",
                    vesselDwt = "",
                    email_subject = "",
                    fleet_id = ""
                  } = item;
                  const isChecked =
                    selectedAutoFleet.find((itm) => itm?._id === item?._id) ||
                    false;
                  return (
                    <TableRow key={index}>
                      <TableCell>
                        <Checkbox
                          size="small"
                          color="primary"
                          checked={!!isChecked}
                          disabled={!!fleet_id}
                          onChange={() => onAutoFleetListCheckBox(item)}
                        />
                      </TableCell>
                      <TableCell>{vesselName}</TableCell>
                      <TableCell>{item?.vesseldata?.vesselDwt}</TableCell>

                      {/* <TableCell>{item?.nearestport?.name}</TableCell> */}
                      <TableCell>
                        <Autocomplete
                          disabled={!!fleet_id}
                          options={
                            (savePortListByIndex?.[index] &&
                              savePortListByIndex?.[index]) ||
                            []
                          }
                          value={item?.nearestport}
                          getOptionLabel={(option) => option.portLabel}
                          disableClearable
                          onChange={(e, value) =>
                            onChangeNewPortValue(index, value, item?._id)
                          }
                          className="autocomplete-mui"
                          getOptionSelected={(option, value) =>
                            option.portLabel === value.portLabel
                          }
                          onInputChange={(event, newInputValue) => {
                            delayPortSearch(index, newInputValue);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              placeholder="Search Port"
                              size="small"
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <React.Fragment>
                                    {(portLoading?.[index] &&
                                      portLoading?.[index]) ||
                                      false ? (
                                      <CircularProgress
                                        color="inherit"
                                        size={15}
                                      />
                                    ) : null}
                                    {params.InputProps.endAdornment}
                                  </React.Fragment>
                                ),
                              }}
                            />
                          )}
                        />
                      </TableCell>
                      <TableCell>{item?.nearestport?.area}</TableCell>

                      {/* <TableCell>{dateOpening}</TableCell> */}
                      <TableCell>
                        <MuiPickersUtilsProvider utils={MomentUtils}>
                          <DateTimePicker
                            disabled={!!fleet_id}
                            inputVariant="outlined"
                            size="small"
                            className="date-time-picker"
                            format="DD/MMM/YYYY HH:mm:A"
                            style={{ width: 160, height: 2 }}
                            value={item?.nearestDate?.date || null}
                            onChange={(date) =>
                              onChangeNewPortValue(index, date, item?._id, true)
                            }
                          />
                        </MuiPickersUtilsProvider>
                        {/* {moment(item?.nearestDate?.date).format("DD/MMM/YYYY HH:mm:A")} */}
                      </TableCell>
                      <TableCell>{item?.vesseldata?.vesselGears}</TableCell>
                      <TableCell>{email_subject}</TableCell>
                      <TableCell>{moment(email_date).format("DD/MMM/YYYY HH:mm:A")}</TableCell>
                      <TableCell>
                        <button
                          disabled={!!fleet_id}
                          className={`flex items-center justify-center gap-1 px-2.5 py-0.5 h-[22px] text-[11px] font-medium text-white rounded-none transition-colors cursor-pointer border-none ${(item.isValidate || !!fleet_id)
                            ? "bg-emerald-600 hover:bg-emerald-700"
                            : "bg-amber-600 hover:bg-amber-700"
                            }`}
                          onClick={() => {
                            setValidationVesselFromAuto(true);
                            setValidationVesselFromAutoIndex(index);
                          }}
                        >
                          {(item.isValidate || !!fleet_id) ? "Verified" : "Verify"}
                        </button>
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : null}
            </TableBody>

          </Table>
          {!loader && !emailFleetList?.length && (
            <div className="sticky left-0 w-full flex flex-col items-center justify-center gap-1.5 py-10 px-4 bg-white text-center">
              <div className="w-12 h-12 flex items-center justify-center bg-slate-100 border border-slate-200 text-slate-400">
                <LuInbox size={24} />
              </div>
              <p className="m-0 text-[12px] font-medium text-slate-700">No Vessels Found.</p>
              <p className="m-0 text-[11px] text-slate-500">Try a longer "Updated since last" range or clear the filters, then press Search.</p>
            </div>
          )}
        </TableContainer>
        <div className="flex justify-end mt-2 mb-1">
          <button
            onClick={onSaveAllVessels}
            className="flex items-center justify-center px-4 h-[26px] text-[11px] font-medium text-white bg-[#313C4C] hover:bg-[#0c2f50] border border-[#313C4C] rounded-none shadow-2xs transition-colors cursor-pointer"
          >
            Add to My Vessels
          </button>
        </div>
      </div>
    </div>
  );
}
